import { AsyncStorage } from 'react-native'
import { DeviceInfo } from 'qunar-react-native';

interface UrlsProxy {
    [propName: string]: any;
}

let BETAHOST:string;

(async() => {
    BETAHOST = await AsyncStorage.getItem('@componentOrderHost');
})();

const URLSProxy:UrlsProxy = {};

const proxyWrap = function(URLS: any, HOTS: string, key: string) {
    URLSProxy[key] = URLSProxy[key] || new Proxy(URLS, {
        get(target, propKey, receiver) {
            let result;
            if (BETAHOST) {
                result = Reflect.get(target, propKey, receiver);
                result = result && result.replace(new RegExp(HOTS), BETAHOST);
            } else {
                // null 是异步取了 @componentOrderHost 的值，但是值为null；
                if (BETAHOST === null) {
                    result = Reflect.get(target, propKey, receiver);
                } else {
                    AsyncStorage.getItem('@componentOrderHost')
                        .then((res) => {
                            result = res;
                            BETAHOST = res;
                        });
                }
            }
            return result;
        }
    });
    return URLSProxy[key];
};

export default function debugHost(URLS: any, HOTS: string,key: string) {

    return DeviceInfo.releaseType === 'beta' ? proxyWrap(URLS,HOTS,key) : URLS;
}
